import { grey, teal } from '@mui/material/colors';
export const primaryTeal = teal[300];
export const buttonDisabled = grey[800];